import { useTranslation, Trans } from 'react-i18next';

const ADDRESS = "http://miriambixso02.github.io/akira-report/"

const Footer = (() => {

  const { t, i18n } = useTranslation();

  return (
    <>
      <footer >
        <div class="row">
          <div class="column column-75 column-offset-10 container">

            <div class="row">
              <div class="column column-25">
                <Trans i18nKey="description.footer1" />
                <br />
                Prof. Edie Miglio e Giuseppe Aloe
                <br />
                <Trans i18nKey="description.footer2" />
                <br />
                <Trans i18nKey="description.footer3" />
                <br />
                A.A. 2023/2024
              </div>
              <div class="column column-offset-10" id="team">
                <span class="italics">Team:</span>
                <br />
                Bissoli Miriam
                <br />
                Giordano Angelo
                <br />
                Turini Davide
              </div>
            </div>

          </div>
        </div>
      </footer >
    </>
  )
})

export default Footer